import { render, staticRenderFns } from "./TableFileUploadModal.vue?vue&type=template&id=f512489e&scoped=true"
import script from "./TableFileUploadModal.vue?vue&type=script&lang=js"
export * from "./TableFileUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512489e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f512489e')) {
      api.createRecord('f512489e', component.options)
    } else {
      api.reload('f512489e', component.options)
    }
    module.hot.accept("./TableFileUploadModal.vue?vue&type=template&id=f512489e&scoped=true", function () {
      api.rerender('f512489e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/TableFileUploadModal.vue"
export default component.exports